import { Autocomplete, Input, MenuItem } from '@trackman/web-shared-components';
import { ServiceTypes } from 'constants/ServiceTypes';
import { ReactComponent as DropdownIcon } from 'images/dropdownIcon.svg';
import { IUmpire } from 'interfaces/umpire/IUmpire';
import { StyledClearIcon } from 'pages/Verify/Components/TopBar/EditSessionModal/components/TeamsAndSettings/TeamsAndSettingsStyles';
import React, { CSSProperties } from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { SessionVerificationStore } from 'stores/SessionVerificationStore';
import { AutocompleteWrapper, IconWrapper, StyledListSubheader } from './UmpireSearchStyles';

interface IProps {
  selectedUmpire?: IUmpire;
  setSelectedUmpire: (umpire: IUmpire) => void;
  width: CSSProperties['width'];
  margin?: CSSProperties['margin'];
  disabled?: boolean;
}

export const UmpireSearch = (props: IProps) => {
  const { selectedUmpire, setSelectedUmpire, width, margin, disabled } = props;
  const sessionStore = useInjection<SessionVerificationStore>(ServiceTypes.SessionVerificationStore);

  const umpireToDropdownMap = (obj: IUmpire) => ({
    label: `${obj.firstName} ${obj.lastName}`,
    value: obj.id,
  });

  return (
    <AutocompleteWrapper>
      <Autocomplete
        width={width}
        options={sessionStore.umpires.map(umpireToDropdownMap)}
        value={selectedUmpire ? umpireToDropdownMap(selectedUmpire).label : ''}
        onChange={(event: any, newValue: any) => {
          setSelectedUmpire(sessionStore.umpires.find((x) => x.id === newValue?.value)!);
        }}
        popupIcon={
          <IconWrapper>
            <DropdownIcon />
          </IconWrapper>
        }
        clearIcon={
          <IconWrapper>
            <StyledClearIcon />
          </IconWrapper>
        }
        renderInput={(params) => {
          return <Input {...params} label='Umpire' />;
        }}
        renderGroup={(params) => (
          <div>
            <StyledListSubheader {...params}>Official umpires to select between:</StyledListSubheader>
            <div style={{ paddingTop: '28px' }}>{params.children}</div>
          </div>
        )}
        groupBy={() => ''}
        renderOption={(params, option) => {
          return (
            <MenuItem {...params} key={option.value}>
              {option.label}
            </MenuItem>
          );
        }}
        margin={margin}
        disabled={disabled}
        data-testid='umpire-search-autocomplete'
      />
    </AutocompleteWrapper>
  );
};
